import { c as create_ssr_component, v as validate_component, i as each, e as escape } from "../../../../../chunks/ssr.js";
import { P as PageLayout } from "../../../../../chunks/PageLayout.js";
import { B as Button } from "../../../../../chunks/Button.js";
import { C as Card } from "../../../../../chunks/Card.js";
import { L as Label } from "../../../../../chunks/Label.js";
import { I as Input } from "../../../../../chunks/Input.js";
import { H as Heading } from "../../../../../chunks/Heading.js";
import { H as Hr } from "../../../../../chunks/Hr.js";
import { A as AsyncTypeAhead } from "../../../../../chunks/AsyncTypeAhead.js";
import { g as get } from "../../../../../chunks/api.js";
import dayjs from "dayjs";
const listEmployees = async (conditions) => {
  const query = new URLSearchParams(conditions).toString();
  return await get(`/employees?${query}`);
};
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let employees = [];
  let inputValue = "";
  const call = async (value) => {
    return await listEmployees("page=1&pageSize=10&search=" + value);
  };
  const extract = async (item) => {
    if (employees.length > 29) {
      alert("Max. 30");
      return;
    }
    inputValue = "asdfasedef";
    employees = [...employees, await get("/employee/" + item.uuid)];
  };
  let newEndDate = dayjs().add(6, "month").format("YYYY-MM-DD");
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(PageLayout, "PageLayout").$$render($$result, { path: "settings/batch" }, {}, {
      default: () => {
        return `${validate_component(Heading, "Heading").$$render(
          $$result,
          {
            class: "text-neutral-500 mb-3",
            tag: "h3"
          },
          {},
          {
            default: () => {
              return `Vertragsverlängerungen`;
            }
          }
        )} <div class="grid grid-cols-3 gap-3"><div class="col-span-2"><div class="mb-12">${each(employees, (employee) => {
          return `<div class="flex gap-3 mt-5 border-b pb-3"><div class="flex-1">${escape(employee.name)}</div> <div class="pr-5">Status: ${escape(employee?.batchStatus || "-")}</div> ${!employee.batchStatus ? `<div>${validate_component(Button, "Button").$$render($$result, { size: "xs", color: "red" }, {}, {
            default: () => {
              return `entfernen`;
            }
          })} </div>` : ``} </div>`;
        })}</div></div> ${validate_component(Card, "Card").$$render($$result, { class: "min-w-full" }, {}, {
          default: () => {
            return `${validate_component(Label, "Label").$$render($$result, { for: "date", class: "space-y-2 mb-3" }, {}, {
              default: () => {
                return `<span data-svelte-h="svelte-194d2wu">Neues Enddatum</span> ${validate_component(Input, "Input").$$render(
                  $$result,
                  {
                    size: "sm",
                    id: "date",
                    type: "date",
                    placeholder: "Neues Enddatum",
                    value: newEndDate
                  },
                  {
                    value: ($$value) => {
                      newEndDate = $$value;
                      $$settled = false;
                    }
                  },
                  {}
                )}`;
              }
            })} ${validate_component(AsyncTypeAhead, "AsyncTypeAhead").$$render(
              $$result,
              {
                label: "Mitarbeiter suchen",
                call,
                extract,
                value: inputValue
              },
              {
                value: ($$value) => {
                  inputValue = $$value;
                  $$settled = false;
                }
              },
              {}
            )}`;
          }
        })}</div> ${employees.length > 0 ? `${validate_component(Hr, "Hr").$$render($$result, {}, {}, {})} <div class="flex gap-5 justify-between"><div class="grid place-content-end">${validate_component(Button, "Button").$$render($$result, { color: "red" }, {}, {
          default: () => {
            return `Alle entfernen`;
          }
        })}</div> <div class="grid place-content-end">${validate_component(Button, "Button").$$render($$result, {}, {}, {
          default: () => {
            return `Verträge verlängern`;
          }
        })}</div></div>` : ``}`;
      }
    })}`;
  } while (!$$settled);
  return $$rendered;
});
export {
  Page as default
};
//# sourceMappingURL=_page.svelte.js.map
